import { useMutation, useQueryClient } from '@tanstack/react-query'

import { segmentsApi } from '@/api/segments/segmentsApi'
import { segmentsQueries } from '@/api/segments/segmentsQueries'

export const useReorderSegmentsMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (segmentIds: string[]) =>
      segmentsApi.reorderSegments(segmentIds),
    onSuccess: (segments) =>
      queryClient.setQueryData(segmentsQueries.list('mine').queryKey, segments),
  })
}
